import { render, staticRenderFns } from "./ChangeHistory.vue?vue&type=template&id=33b421a4&scoped=true&"
import script from "./ChangeHistory.vue?vue&type=script&lang=js&"
export * from "./ChangeHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChangeHistory.vue?vue&type=style&index=0&id=33b421a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b421a4",
  null
  
)

export default component.exports